import type { AvailabilityResponseModel } from "../Models/BookingModels";
import { AppService, type HttpClientModel, type Result } from "./App.service";
import { normalizeAvailabilityFn } from "../../Features/Calendar/Functions";

export const CalendarService = {
  async getAvailability(
    client: HttpClientModel = AppService.httpClient,
    query?: { event: string; month: string },
    signal?: AbortSignal,
  ): Promise<Result<AvailabilityResponseModel>> {
    try {
      const response = await client.get("/api/availability", { params: query, signal });
      const normalized = normalizeAvailabilityFn(response.data);
      if (!normalized || normalized.source !== "api") throw new Error("Unverified availability");
      return { ok: true, data: normalized };
    } catch {
      return { ok: false, error: query
        ? "Live times could not be loaded. Please try again or check availability directly on Cal.com."
        : "Choose a package to see live availability, or contact the studio for help." };
    }
  },
};
export default CalendarService;
